/**
 * Los datos de la página /alternativa-harbiz, en un solo sitio.
 *
 * Los leen la página (src/pages/AlternativaHarbiz.jsx) y el cuerpo que se
 * prerenderiza para los crawlers sin JavaScript (src/data/landingBodies.js), y
 * la tabla de /coaches cita las mismas cifras. Si Harbiz cambia sus tarifas,
 * se cambian AQUÍ y en CoachLandingComparison.jsx.
 *
 * ⚠️ Todo lo que se diga de Harbiz tiene que salir de su web y llevar fecha.
 * Comparar con un competidor por su nombre es legal si es objetivo y
 * comprobable; una cifra inventada o vieja no lo es.
 */
import { PRECIO_ANUAL } from "../config/precios.js";

/** Cuándo se miraron las tarifas en harbiz.io/tarifas. */
export const HARBIZ_CONSULTADO = "1 de octubre de 2026";

/** Planes de Harbiz: mensual / pagando el año (por mes) y su límite de clientes. */
export const HARBIZ_PLANES = [
  { plan: "Basic", mensual: 19, anual: 14, clientes: "hasta 5 clientes" },
  { plan: "Pro", mensual: 119, anual: 89, clientes: "hasta 50 clientes" },
  { plan: "My App", mensual: 199, anual: 149, clientes: "hasta 50 clientes, con app de marca" },
];

/** Extras de pago de Harbiz, por mes. */
export const HARBIZ_EXTRAS = [
  { extra: "App con tu marca", precio: "24,99" },
  { extra: "Nutri AI", precio: "14,99" },
  { extra: "Video Library", precio: "19,99" },
];

/** Lo que cuesta cada caso al año, para que se vea con números de verdad. */
export const CASOS = [
  { clientes: 5, harbiz: "Basic: de 168 a 228 € al año" },
  { clientes: 20, harbiz: "Pro: de 1.068 a 1.428 € al año" },
  { clientes: 50, harbiz: "Pro: de 1.068 a 1.428 € al año, y es el tope del plan" },
];

/**
 * Donde Harbiz es MEJOR. Va en la página a propósito: quien compara software
 * se fía más de una comparativa que reconoce lo que el otro hace bien, y así
 * no se nos registra nadie que necesita reservas y se va enfadado.
 * ⛔ Wayo NO tiene reservas de clases, NI cobros dentro de la app, NI app con
 * la marca del entrenador.
 */
export const DONDE_GANA_HARBIZ = [
  "Agenda y reservas de clases para tus clientes",
  "Cobros y facturación dentro de la plataforma",
  "Una app publicada con tu nombre y tu logo (plan My App o extra de pago)",
  "Tu propia web para vender tus planes",
];

export const DONDE_GANA_WAYO = [
  "Gratis para el profesional: 0 € al mes, siempre",
  "Sin límite de clientes: el precio no sube cuando creces",
  "IA de nutrición y biblioteca de vídeos incluidas, sin extras",
  "Tus clientes registran su comida con una foto y tienen un asistente con IA",
];

export const PREGUNTAS = [
  [
    "¿Wayo Coach es gratis de verdad?",
    "Sí. No hay cuota mensual, ni de alta, ni límite de clientes, ni permanencia. Wayo gana dinero con las suscripciones Premium de los usuarios de la app, no cobrando al profesional.",
  ],
  [
    "¿Mis clientes tienen que pagar algo?",
    `Sí, y es la diferencia más importante con Harbiz, que es gratis para tus clientes. En Wayo, tu cliente necesita Wayo Premium (${PRECIO_ANUAL} al año): es la app con la que sigue tu plan, registra su comida con una foto y habla con el asistente. Lo paga él a Wayo, no a ti; si quieres, lo incluyes en tu tarifa.`,
  ],
  [
    "¿Qué pierdo si dejo Harbiz?",
    "Las reservas de clases, los cobros dentro de la plataforma, la app con tu marca y la web propia: Wayo no tiene nada de eso. Tus cobros los sigues gestionando tú, como antes (transferencia, Bizum, PayPal…), y en el panel apuntas quién te ha pagado y quién no.",
  ],
  [
    "¿Puedo pasar mis clientes de Harbiz a Wayo?",
    "No hay importación automática. Das de alta a cada cliente desde tu panel con su correo, y sus rutinas y planes los montas en el diseñador; el de nutrición lo hace la IA en segundos y tú lo retocas.",
  ],
  [
    "¿Puedo probar Wayo sin dejar Harbiz?",
    "Sí. Como es gratis y no tiene permanencia, puedes empezar con unos pocos clientes en Wayo y decidir después.",
  ],
  [
    "¿Para quién NO es Wayo Coach?",
    "Para un estudio que vive de las reservas de clases o necesita cobrar dentro de la app. Ahí Harbiz o un software de reservas te encajan mejor.",
  ],
];
